// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';



// Registro de elementos necesarios de Chart.js
import {
    Chart as ChartJS,
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

import { BrowserRouter as Router } from 'react-router-dom';

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const root = ReactDOM.createRoot(document.getElementById('root'));

/* 
   Si tu aplicación se sirve desde la ruta /app, 
   entonces basename debería ser "/app".
   Si la sirves directamente desde "/", deja basename="" 
   (o simplemente elimina la prop basename).
*/
root.render(
  <React.StrictMode>
    <Router basename="/app">
      <App />
    </Router>
  </React.StrictMode>
);

// Si deseas capturar métricas de rendimiento, descomenta la función y pásala como callback:
reportWebVitals();
